import React from 'react';
import CancelledJob from './cancelled-job';
import CompletedJob from './completed-job';
import FailedJob from './failed-job';
import InProgressJob from './in-progress-job';
import QueuedJob from './queued-job';

const Job = ({
  job,
  downloadUrl,
  dispatch,
  ...rest
}) => {
  switch (job.statusType) {
    case 'queued':
      return /*#__PURE__*/React.createElement(QueuedJob, Object.assign({
        job: job,
        onCancel: () => dispatch({
          type: 'CANCEL',
          jobKey: job.jobKey
        })
      }, rest));

    case 'inProgress':
      return /*#__PURE__*/React.createElement(InProgressJob, Object.assign({
        job: job,
        onCancel: () => dispatch({
          type: 'CANCEL',
          jobKey: job.jobKey
        }),
        onDismiss: () => dispatch({
          type: 'DISMISS',
          jobKey: job.jobKey
        })
      }, rest));

    case 'completed':
      return /*#__PURE__*/React.createElement(CompletedJob, Object.assign({
        job: job,
        createDownloadUrl: () => dispatch({
          type: 'CREATE_DOWNLOAD_URL',
          jobKey: job.jobKey
        }),
        onDismiss: () => dispatch({
          type: 'DISMISS',
          jobKey: job.jobKey
        }),
        downloadUrl: downloadUrl
      }, rest));

    case 'failed':
      return /*#__PURE__*/React.createElement(FailedJob, Object.assign({
        job: job,
        onRetry: () => dispatch({
          type: 'RETRY',
          jobKey: job.jobKey
        }),
        onDismiss: () => dispatch({
          type: 'DISMISS',
          jobKey: job.jobKey
        })
      }, rest));

    case 'cancelled':
      return /*#__PURE__*/React.createElement(CancelledJob, Object.assign({
        job: job,
        onRetry: () => dispatch({
          type: 'RETRY',
          jobKey: job.jobKey
        }),
        onDismiss: () => dispatch({
          type: 'DISMISS',
          jobKey: job.jobKey
        })
      }, rest));

    default:
      {
        const unsupported = job;
        throw new Error(`${unsupported} is unsupported`);
      }
  }
};

export default Job;